import React from 'react';
import { PropertyTypeTabItemWrapper } from './PropertyTypeTabItem.style';

interface PropertyTypeTabItemProps {
  tab: Tab;
  onClickTabCard?: (tab: string) => void;
}

interface Tab {
  label: string;
  name: string;
  url: string;
  image: string;
}
export const PropertyTypeTabItem: React.FC<PropertyTypeTabItemProps> = ({
  tab,
  onClickTabCard,
}) => {
  const { label, url, image, name } = tab;

  return (
    <PropertyTypeTabItemWrapper href={url} onClick={() => onClickTabCard(name)}>
      <img src={image} alt="" />
      <span>{label}</span>
    </PropertyTypeTabItemWrapper>
  );
};
